// extracted by mini-css-extract-plugin
export default {"search":"Search_search__KgHES","sr-only":"Search_sr-only__zlXTS","dark":"Search_dark__WG2gh"};